// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"HomeLayout_wrapper__yIAgA"};